var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptySearch = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 128,
  height: 128,
  viewBox: "0 0 128 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5363_26304)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 60.7768,
  cy: 62.7768,
  r: 60.7768,
  fill: "#E4F5FC"
}), /*#__PURE__*/React.createElement("circle", {
  opacity: 0.2,
  cx: 60.7767,
  cy: 62.7787,
  r: 47.2709,
  fill: "#0090C1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.029 103.448H32.6552C31.1888 103.448 30 102.26 30 100.793V24.6552C30 23.1888 31.1888 22 32.6552 22H76.6726L91.6842 35.8569V100.793C91.6842 102.26 90.4955 103.448 89.029 103.448Z",
  fill: "#F5F8FF",
  stroke: "#A7B2CD",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.7852 39.0229C36.7852 38.0136 37.6034 37.1953 38.6127 37.1953H73.9995C75.0089 37.1953 75.8271 38.0136 75.8271 39.0229C75.8271 40.0322 75.0089 40.8505 73.9995 40.8505H38.6127C37.6034 40.8505 36.7852 40.0322 36.7852 39.0229ZM36.7852 50.2878C36.7852 49.2784 37.6034 48.4602 38.6127 48.4602H84.2731C85.2825 48.4602 86.1007 49.2784 86.1007 50.2878C86.1007 51.2971 85.2825 52.1154 84.2731 52.1154H38.6127C37.6034 52.1154 36.7852 51.2971 36.7852 50.2878ZM36.7852 61.5527C36.7852 60.5433 37.6034 59.7251 38.6127 59.7251H51.1693C52.1787 59.7251 52.9969 60.5433 52.9969 61.5527C52.9969 62.562 52.1787 63.3803 51.1693 63.3803H38.6127C37.6034 63.3803 36.7852 62.562 36.7852 61.5527ZM57.3323 61.5527C57.3323 60.5433 58.1506 59.7251 59.1599 59.7251H84.2731C85.2825 59.7251 86.1007 60.5433 86.1007 61.5527C86.1007 62.562 85.2825 63.3803 84.2731 63.3803H59.1599C58.1506 63.3803 57.3323 62.562 57.3323 61.5527ZM36.7852 72.8176C36.7852 71.8082 37.6034 70.99 38.6127 70.99H71.7165C72.7259 70.99 73.5441 71.8082 73.5441 72.8176C73.5441 73.8269 72.7259 74.6452 71.7165 74.6452H38.6127C37.6034 74.6452 36.7852 73.8269 36.7852 72.8176ZM77.8795 72.8176C77.8795 71.8082 78.6977 70.99 79.7071 70.99H84.2731C85.2825 70.99 86.1007 71.8082 86.1007 72.8176C86.1007 73.8269 85.2825 74.6452 84.2731 74.6452H79.7071C78.6977 74.6452 77.8795 73.8269 77.8795 72.8176ZM36.7852 82.956C36.7852 81.9466 37.6034 81.1284 38.6127 81.1284H80.8486C81.8579 81.1284 82.6762 81.9466 82.6762 82.956C82.6762 83.9653 81.8579 84.7836 80.8486 84.7836H38.6127C37.6034 84.7836 36.7852 83.9653 36.7852 82.956ZM36.7852 93.0944C36.7852 92.085 37.6034 91.2668 38.6127 91.2668H69.4335C70.4428 91.2668 71.2611 92.085 71.2611 93.0944C71.2611 94.1037 70.4428 94.922 69.4335 94.922H38.6127C37.6034 94.922 36.7852 94.1037 36.7852 93.0944Z",
  fill: "#E4E7F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.7852 39.0229C36.7852 38.0136 37.6034 37.1953 38.6127 37.1953H73.9995C75.0089 37.1953 75.8271 38.0136 75.8271 39.0229C75.8271 40.0322 75.0089 40.8505 73.9995 40.8505H38.6127C37.6034 40.8505 36.7852 40.0322 36.7852 39.0229Z",
  fill: "#E4E7F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.0635 21L92.6841 35.4191H81.0635C78.8543 35.4191 77.0635 33.6282 77.0635 31.4191V21Z",
  fill: "#A7B2CD"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.3412,
  cy: 58.3412,
  r: 4.3412,
  stroke: "#E66A8B",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116.608,
  cy: 71.6078,
  r: 3.60776,
  stroke: "#11BC97",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.1101,
  cy: 79.1101,
  r: 1.11008,
  stroke: "#0090C1",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.7396 89.7805L89.6901 83.8299L114.211 104.759C117.214 107.322 117.395 111.901 114.603 114.693C111.811 117.485 107.232 117.304 104.669 114.301L83.7396 89.7805Z",
  fill: "#110133"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.9644 94.7276L104.669 114.299C107.232 117.302 111.811 117.482 114.603 114.69C117.395 111.899 117.214 107.319 114.211 104.756L92.3639 86.1094C91.4848 89.2789 89.9717 92.1968 87.9644 94.7276Z",
  fill: "#110133"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.627 59.0059C61.8268 60.8284 59.6087 63.4653 58.2625 66.5903C56.9161 69.716 56.5054 73.1834 57.0854 76.5518C57.6654 79.9199 59.2081 83.0286 61.5093 85.4876C63.8099 87.9458 66.7644 89.6439 69.9951 90.3772C73.2254 91.1104 76.596 90.8485 79.6835 89.6223L79.6838 89.6222C81.7348 88.8079 83.6128 87.587 85.209 86.026C86.8054 84.465 88.0886 82.5944 88.9824 80.5194C89.8763 78.4444 90.3624 76.2074 90.4113 73.9367C90.4602 71.666 90.071 69.4089 89.2671 67.2949L89.267 67.2947C88.0567 64.1107 85.9537 61.375 83.2336 59.4269C80.5142 57.4794 77.2979 56.4043 73.9914 56.3296C70.685 56.255 67.4264 57.1839 64.627 59.0059ZM53.088 64.3613C54.8678 60.2295 57.8106 56.7199 61.5536 54.2838C65.2973 51.8472 69.6702 50.5964 74.1186 50.6969C78.567 50.7973 82.8806 52.2441 86.5141 54.8463C90.1468 57.448 92.9343 61.0856 94.5335 65.2926C95.5958 68.0863 96.1087 71.0646 96.0442 74.0581C95.9797 77.0517 95.3389 80.0045 94.157 82.7484C92.9749 85.4925 91.2739 87.9756 89.1482 90.0543C87.0224 92.1331 84.5135 93.7667 81.7631 94.8587C77.6203 96.5039 73.0901 96.8572 68.748 95.8717C64.4064 94.8863 60.4571 92.6088 57.3956 89.3375C54.3346 86.0668 52.2976 81.9491 51.5329 77.5079C50.7682 73.0669 51.3083 68.4927 53.088 64.3613Z",
  fill: "#110133"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10.8561,
  height: 1.87174,
  rx: 0.935869,
  transform: "matrix(-0.707107 0.707107 0.707107 0.707107 44.6763 109)",
  fill: "#110133"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10.8561,
  height: 1.87174,
  rx: 0.935869,
  transform: "matrix(0.707107 0.707107 0.707107 -0.707107 37 110.324)",
  fill: "#110133"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5363_26304"
}, /*#__PURE__*/React.createElement("rect", {
  width: 128,
  height: 128,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptySearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-search.5911d177865ac1149fc64f407d2487d5.svg";